<script lang="ts">
  interface Props {
    checked?: boolean;
    label?: string;
    description?: string;
    disabled?: boolean;
    size?: 'sm' | 'md';
    onchange?: (checked: boolean) => void;
    id?: string;
  }
  let { checked = $bindable(false), label, description, disabled = false, size = 'md', onchange, id }: Props = $props();
  const fallbackId = `tg-${Math.random().toString(36).slice(2, 8)}`;
  const uid = $derived(id || fallbackId);
  function toggle() {
    if (disabled) return;
    checked = !checked;
    onchange?.(checked);
  }
</script>

<div class="toggle-row" class:disabled>
  {#if label || description}
    <label class="text" for={uid}>
      {#if label}<span class="label">{label}</span>{/if}
      {#if description}<span class="desc">{description}</span>{/if}
    </label>
  {/if}
  <button id={uid} type="button" role="switch" aria-checked={checked} aria-label={label} class="switch {size}" class:on={checked} {disabled} onclick={toggle}>
    <span class="knob"></span>
  </button>
</div>

<style>
  .toggle-row { display: flex; align-items: center; justify-content: space-between; gap: var(--space-4); }
  .toggle-row.disabled { opacity: 0.55; }
  .text { display: flex; flex-direction: column; gap: var(--space-0_5); cursor: pointer; min-width: 0; }
  .label { font-size: var(--text-base); font-weight: var(--weight-semibold); color: var(--text); }
  .desc { font-size: var(--text-sm); color: var(--text-2); }
  .switch {
    position: relative;
    width: 40px;
    height: 24px;
    border-radius: var(--radius-full);
    border: 0;
    padding: 0;
    background: var(--border-strong);
    transition: background var(--dur) var(--ease);
    flex-shrink: 0;
  }
  .switch:focus-visible { outline: none; box-shadow: var(--ring); }
  .switch.sm { width: 34px; height: 20px; }
  .switch.on { background: var(--brand); }
  .knob {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 18px;
    height: 18px;
    border-radius: var(--radius-full);
    background: var(--control-knob);
    box-shadow: var(--shadow-sm);
    transition: transform var(--dur) var(--ease);
  }
  .sm .knob { width: 14px; height: 14px; }
  .on .knob { transform: translateX(16px); }
  .sm.on .knob { transform: translateX(14px); }
</style>
